export let API_URL;
export let Redirect_URI;

if (process.env.NODE_ENV === "development") {
  //console.log("Starting Locally");
  //API_URL = "http://localhost:80/";
  API_URL = "http://localhost:80/";
  Redirect_URI = "/";
} else {
  // TODO: change this to work in docker environment (if required)
  //console.log("Starting on Azure");
  API_URL =
    "https://mitarbeiterportal-backend-abc8bubxdpddg3du.westeurope-01.azurewebsites.net/";
  Redirect_URI = "/";
}
